<template>
  <div
    class="prosecco-hero"
    :class="{ scrolled: $store.state.page.scrolled }"
    data-in-out
    data-in-out-animation="stagger-text"
    data-in-out-order="3"
    data-in-delay="0.4"
  >
    <h1 class="prosecco-hero__title">{{ title }}</h1>
  </div>
</template>

<script>
import { SplitText } from '@/scripts/libs/SplitText';

export default {
  name: 'PageHero',

  props: ['title'],

  mounted() {
    new SplitText(this.$el.querySelector('h1'), { charsClass: 'stagger-element', }); // eslint-disable-line
  },
};
</script>

<style lang="scss" scoped>
.prosecco-hero {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  h1 {
    position: relative;
    font-size: rem(300px);
    font-size: calc(300px * var(--rw));
    color: $color-white;
    font-weight: 300;
    top: calc((100vh / 18) * 7);
    left: calc((100vw / 32) * 7);
    line-height: 1;
    transform: translateY(0px);
    transition: opacity 0.6s $inOutCubic,
                transform 0.6s $inOutCubic;

    @include mq($until: ds) {
      font-size: rem(220px);
      font-size: calc(220px * var(--rw));
      left: calc((100vw / 32) * 4);
    }

    @include mq($until: ipadP) {
      font-size: rem(90px);
      font-size: calc(90px * var(--rw));
      top: calc((100vh / 18) * 10.5);
      left: calc((100vw / 32) * 4);
    }
  }

  &.scrolled {
    pointer-events: none;

    h1 {
      opacity: 0;
      // transform: translateY(-80px);
    }
  }
}
</style>
